/**
 *  IMPORTANT: When changing the schema version here also update it to the same value in dashboard/src/services/workspaces/workspaces.epic.ts
 */
export const SCHEMA_VERSION = 3;
